import { common } from '@ocean/ui'
import { Wrapper } from './Hint.styled'
import { HintVariant } from './types'

const { Typography } = common

type HintProps = {
  variant?: HintVariant
  fill?: boolean
}

const Hint: React.FC<HintProps> = ({ children, variant, fill }) => {
  return (
    <div>
      <Wrapper variant={variant} $fill={fill}>
        <Typography variant='small'>
          <b>{children}</b>
        </Typography>
      </Wrapper>
    </div>
  )
}

export default Hint
